<div>
  <p>
    We’ve updated our Terms & Conditions. Please review and accept the new terms to continue using our services.
  </p>
  @if (showContent() && termsOfService()) {
    <div 
      class="content"
      [innerHTML]="termsOfService()!.content"
    ></div>
  }
</div>
<div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 12px;">
  <p-button
    (click)="toggleContent()"
    severity="secondary"
    [rounded]="true"
    [label]="showContent() ? 'Show less' : 'Show the full terms'"
  ></p-button>
  <p-button
    (click)="accept()"
    severity="primary"
    [rounded]="true"
    label="Accept and continue"
  ></p-button>
</div>